import {
  Component,
  Directive,
  TemplateRef,
  ContentChildren,
  QueryList,
  Input,
  OnDestroy,
  AfterContentChecked,
  OnInit
} from '@angular/core';

import {NgbCarouselConfig} from './carousel.config';

let nextId = 0;
@Directive({selector: 'ng-template[nucSlide]'})
export class NucSlide {
  @Input() id = `ngb-slide-${nextId++}`;
  constructor(public tplRef: TemplateRef<any>) {

  }
}

@Component({
  selector: 'nuc-carousel',
  exportAs: 'nucCarousel',
  host: {
    'class': 'carousel slide',
    '[style.display]': '"block"',
    'tabIndex': '0',
    '(keydown.arrowLeft)': 'keyPrev()',
    '(keydown.arrowRight)': 'keyNext()'
  },
  template: `
    <ol class="carousel-indicators">
      <li *ngFor="let slide of slides" [id]="slide.id" [class.active]="slide.id === activeId"></li>
    </ol>
    <div class="carousel-inner">
      <div *ngFor="let slide of slides" class="item" [class.active]="slide.id === activeId" 
     [class.left] ="leftSlideId === slide.id" [class.right] ="rightSlideId === slide.id"
     [class.prev] = "prevSlideId === slide.id"  [class.next] = "nextSlideId === slide.id">
        <ng-template [ngTemplateOutlet]="slide.tplRef"></ng-template>
      </div>
    </div>
    <a class="left carousel-control" role="button" (click)="cycleToPrev()" *ngIf="hasPrev()">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="right carousel-control" role="button" (click)="cycleToNext()" *ngIf="hasNext()">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
    `,
})
export class NucCarousel implements AfterContentChecked,
  OnDestroy, OnInit {
  @ContentChildren(NucSlide) slides: QueryList<NucSlide>;

  private prevSlideId ;
  private leftSlideId;
  private nextSlideId;
  private rightSlideId;

  @Input() interval: number;
  @Input() wrap: boolean;
  @Input() keyboard: boolean;
  @Input() activeId: string;

  constructor(config: NgbCarouselConfig) {
    this.interval = config.interval;
    this.wrap = config.wrap;
    this.keyboard = config.keyboard;
  }

  ngAfterContentChecked() {
    let activeSlide = this.getSlideById(this.activeId);
    this.activeId = activeSlide ? activeSlide.id : (this.slides.length ? this.slides.first.id : null);
  }

  ngOnInit() {  }

  ngOnDestroy() { }

  select(slideId: string) {
    this.cycleToSelected(slideId);
  }

  hasPrev(): boolean {
     return this.slides.length > 1 &&  !(this.slides.first.id === this.activeId);
   }
   hasNext(): boolean {
     return this.slides.length > 1 && !(this.slides.last.id === this.activeId);
   }

  prev() {
    this.cycleToPrev();
  }

  next() {
    this.cycleToNext();
  }

  cycleToNext() { this.cycleToSelected(this.getNextSlide(this.activeId)); }

  cycleToPrev() { this.cycleToSelected(this.getPrevSlide(this.activeId)); }

  cycleToSelected(slideIdx: string) {
    let selectedSlide = this.getSlideById(slideIdx);
    if (selectedSlide) {
      setTimeout(() => {
        this.activeId = selectedSlide.id;
        this.leftSlideId = null;
        this.nextSlideId = null;
        this.rightSlideId = null;
        this.prevSlideId = null;
      }, 300);

    }
  }

  keyPrev() {
    if (this.keyboard) {
      this.prev();
    }
  }

  keyNext() {
    if (this.keyboard) {
      this.next();
    }
  }

  private getSlideById(slideId: string): NucSlide {
    let slideWithId: NucSlide[] = this.slides.filter(slide => slide.id === slideId);
    return slideWithId.length ? slideWithId[0] : null;
  }

  private getSlideIdxById(slideId: string): number {
    return this.slides.toArray().indexOf(this.getSlideById(slideId));
  }

  private getNextSlide(currentSlideId: string): string {
    const slideArr = this.slides.toArray();
    const currentSlideIdx = this.getSlideIdxById(currentSlideId);
    const isLastSlide = currentSlideIdx === slideArr.length - 1;
    this.leftSlideId = currentSlideId;
    this.nextSlideId = isLastSlide ? slideArr[0].id : slideArr[currentSlideIdx + 1].id;

    return isLastSlide ? (this.wrap ? slideArr[0].id : slideArr[slideArr.length - 1].id) :
      slideArr[currentSlideIdx + 1].id;
  }

  private getPrevSlide(currentSlideId: string): string {
    const slideArr = this.slides.toArray();
    const currentSlideIdx = this.getSlideIdxById(currentSlideId);
    const isFirstSlide = currentSlideIdx === 0;
    this.rightSlideId = currentSlideId;
    this.prevSlideId = isFirstSlide ? slideArr[0].id : slideArr[currentSlideIdx - 1].id;

    return isFirstSlide ? (this.wrap ? slideArr[slideArr.length - 1].id : slideArr[0].id) :
      slideArr[currentSlideIdx - 1].id;
  }
}

export const CAROUSEL_DIRECTIVES = [NucCarousel, NucSlide];



// WEBPACK FOOTER //
// ./src/app/shared/carousel/carousel.component.ts